export default function trackerController() {
    return {
        // No need to duplicate the store state here

        initTrackerController() {
            // Load saved progress from cookie
            const savedProgress = this.getSavedProgress();
            if (savedProgress) {
                // Update the store directly instead of local state
                savedProgress.forEach(itemId => this.$store.tracker.addItem(itemId));
                this.updateTrackerItems();
            }
        },

        handleRiveClick(canvasId) {
            const canvas = document.getElementById(canvasId);
            if (!canvas) return;

            // Get the tracker ID from the canvas
            const trackerId = canvas.dataset.trackerId;
            if (!trackerId) return;

            // Find the corresponding tracker item
            const trackerItem = document.querySelector(`.tracker-menu__item[data-tracker-item="${trackerId}"]`);
            if (!trackerItem) return;

            // Get the item title
            const itemTitle = trackerItem.dataset.title;

            // Add to discovered items using the store method
            this.$store.tracker.addItem(trackerId);

            // Update the tracker item appearance
            trackerItem.classList.remove('tracker-menu__item--locked');
            const titleSpan = trackerItem.querySelector('.item-title');
            if (titleSpan) {
                titleSpan.textContent = itemTitle;
            }

            // Save progress
            this.saveProgress();

            // Open menu and show the detail panel using the store methods
            this.$store.trackerMenu.showDetail(trackerId);

						// Handle sound on mobile/tablet
						//
						const hoverSoundElement = document.getElementById(`hoverSound-${canvasId.split('-')[1]}`);

						if (canvas.getAttribute('data-not-trackable') == '1' || window.innerWidth > 1024 || !hoverSoundElement) return;

						canvas.classList.add("cursor-binocular");
						if (hoverSoundElement && !this.$store.audio.isMuted) {
							console.log('asdsdasd');

							hoverSoundElement.volume = 1;
							hoverSoundElement.loop = true;
							hoverSoundElement.play().catch(console.error);
						}

						setTimeout(() => {
							canvas.classList.remove("cursor-binocular");
							if (hoverSoundElement && !this.$store.audio.isMuted) {
								const fadeOut = setInterval(() => {
									if (hoverSoundElement.volume > 0.1) {
										hoverSoundElement.volume -= 0.1;
									} else {
										hoverSoundElement.pause();
										hoverSoundElement.currentTime = 0;
										clearInterval(fadeOut);
									}
								}, 50);
							}
						}, 1000)
        },

        updateTrackerItems() {
            // Update all tracker items based on discovered state from the store
            this.$store.tracker.getItems().forEach(itemId => {
                const trackerItem = document.querySelector(`.tracker-menu__item[data-tracker-item="${itemId}"]`);
                if (trackerItem) {
                    trackerItem.classList.remove('tracker-menu__item--locked');
                    const titleSpan = trackerItem.querySelector('.item-title');
                    if (titleSpan) {
                        titleSpan.textContent = trackerItem.dataset.title;
                    }
                }
            });
        },

        getSavedProgress() {
            const savedProgress = document.cookie.split('; ').find(row => row.startsWith('discoveredItems='));
            if (savedProgress) {
                try {
                    return JSON.parse(decodeURIComponent(savedProgress.split('=')[1]));
                } catch (e) {
                    console.error('Error parsing saved progress:', e);
                    return null;
                }
            }
            return null;
        },

        saveProgress() {
            // Save to cookie with 30 day expiration using the store's getItems method
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 30);
            document.cookie = `discoveredItems=${encodeURIComponent(JSON.stringify(this.$store.tracker.getItems()))};expires=${expirationDate.toUTCString()};path=/`;
        }
    };
}
